import React from 'react';
import { connect } from 'react-redux';
import { DAY_DATE_FORMAT } from '@/helpers/constants';
import { getFullFormattedDate } from '@/helpers/utils';
import useAppLanguage from '@/hooks/useAppLanguage';
import { getSettingsInfo } from '@/redux/User/user.reducer';
import styles from './NewsDashboard.module.scss';

const NewsDashboard = (props) => {
  const { news, timeZone } = props;
  const lang = useAppLanguage();

  return (
    <div className={styles.News}>
      <i className={`di icon-rss-feed ${styles.NewsfeedIcon}`} />
      <div className={styles.NewsBlock}>
        <div className={styles.NewsTitle}>
          <p>{getFullFormattedDate(news.publicationDate, timeZone, DAY_DATE_FORMAT)}</p>
          <p>{news.title[lang]}</p>
        </div>
        <div className={`plain-html ${styles.NewsText}`} dangerouslySetInnerHTML={{ __html: news.text[lang] }} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  timeZone: getSettingsInfo(state)?.timezone,
});

export default connect(mapStateToProps)(NewsDashboard);
